import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function Deposite() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "	Phone",
      accessorKey: "Phone",
    },
    {
      header: "Amount",
      accessorKey: "Amount",
    },
    {
      header: "Return Amoount	",
      accessorKey: "ReturnAmoount",
    },
    {
      header: "Date",
      accessorKey: "Date",
    },
    {
      header: "Description",
      accessorKey: "Description",
    },
    {
      header: "Note",
      accessorKey: "Note",
    },
    {
      header: "Added By	",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },
  ]);
  const [data] = useState([
      
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Deposite"}
        
      />
    </main>
  );
}

export default Deposite;
